<template>
  <div class="rms-open-table">
    <a-spin :spinning="loading">
      <a-layout>
        <a-layout-content>
          <div class="booking-form-box">
            <div class="title">
              基础信息
            </div>

            <data-form
              ref="orderForm"
              labelSize="small"
              :content="orderFormContent"
              :fixedLabelWidth="true"
              :labelCol="5"
              :wrapperCol="19"
              :colnum="4"
              :showButton="false"
              style="width:90%"
            >
              <template slot="checkInTime">
                <label style="display:inline-block;width:80px;text-align:right"
                  ><span style="color:#f00">*</span>用餐时间：</label
                >
                <a-date-picker
                  v-model="inDate"
                  style="width:135px;"
                  :disabledDate="disabledDate"
                />
                <a-time-picker
                  style="margin-left:5px;width:150px;"
                  v-model="inTime"
                  format="HH:mm"
                />
              </template>
            </data-form>
            <div class="title">
              客人信息
            </div>
            <data-form
              ref="guestForm"
              labelSize="small"
              :content="guestFormContent"
              :fixedLabelWidth="true"
              :labelCol="6"
              :wrapperCol="18"
              :colnum="3"
              :showButton="false"
              style="width:90%"
            >
              <template slot="cardNo">
                <span
                  class="card-no"
                  style="float:left;width: calc(100% - 100px);"
                  @click="handleMemberCardNo"
                  >{{ member.Name }}
                  <span class="clear" @click="clearMemberCardNo">
                    <a-icon type="close-circle"
                  /></span>
                </span>
                <a-button
                  type="primary"
                  @click="readCard"
                  :loading="readLoading"
                  style="margin-top:5px;margin-left:5px"
                  >读卡</a-button
                >
              </template>
            </data-form>
            <div class="footer-action-box">
              <a-popconfirm
                title="确定取消操作吗?"
                ok-text="确定"
                cancel-text="取消"
                @confirm="
                  $router.push({
                    name: 'RestaurantOrderList'
                  })
                "
              >
                <a-button>取消</a-button>
              </a-popconfirm>
              <a-button type="primary" @click="onSubmit(0)" v-if="!isEdit"
                >预订并点菜</a-button
              >
              <a-button type="primary" @click="onSubmit(1)" v-if="!isEdit"
                >仅预订</a-button
              >
              <a-button type="primary" @click="onSubmit(2)" v-if="isEdit"
                >确认修改</a-button
              >
            </div>
          </div>
        </a-layout-content>
      </a-layout>
    </a-spin>
  </div>
</template>
<script>
import { DataForm } from "@/components/dataForm";
import "./../rms.less";
import { cache } from "@/utils/common";
import moment from "moment";
import { MemberListModal } from "@/views/roommanage/index.js";
export default {
  components: {
    DataForm
  },
  data() {
    return {
      inDate: null,
      inTime: null,
      orderFormContent: [
        {
          label: "就餐人数",
          name: "PersonCount",
          type: "number",
          option: {
            initialValue: 1,
            rules: [{ required: true, message: "就餐人数必填" }]
          }
        },
        {
          label: "客源",
          name: "GuestSourceId",
          type: "select",
          api: "Common_GetSelect",
          param: { Types: "ResGuestSource" },
          dataField: "Data.ResGuestSource"
        },
        {
          label: "客户",
          name: "CustomerId",
          type: "select",
          api: "Common_GetSelect", //请求接口api
          param: { Types: "customer" }, //请求参数
          dataField: "Data.customer", //请求可选项返回的数据字段
          props: {
            showSearch: true,
            optionFilterProp: "children"
          }
        },
        {
          name: "SalesmanName",
          type: "hidden"
        },
        {
          label: "业务员",
          name: "SalesmanId",
          type: "select",
          api: "Common_GetSelect", //请求接口api
          param: { Types: "Salesman" }, //请求参数
          dataField: "Data.Salesman", //请求可选项返回的数据字段
          onChange: this.onSalesmanChange,
          load: data => {
            const user = cache.get("user");
            const res = data.find(el => el.Id == user.OperatorId);
            if (res) {
              this.$nextTick(() => {
                const formData = this.$refs.orderForm.getData();
                this.$refs.orderForm.setData({
                  ...formData,
                  SalesmanId: res.Id,
                  SalesmanName: res.Text
                });
              });
            }
          }
        },
        {
          // label: "用餐时间",
          type: "date",
          slot: "checkInTime",
          colnum: 3
          // name: "CheckInTime",
          // format: "YYYY-MM-DD HH:mm",
          // props: {
          //   showTime: true,
          //   format: "YYYY-MM-DD HH:mm",
          //   disabledDate: current =>
          //     current && current < moment().startOf("day")
          // },
          // option: {
          //   rules: [{ required: true, message: "用餐时间必填" }]
          // }
        }
      ],
      guestFormContent: [
        {
          label: "会员卡",
          placeholder: "请输入会员卡",
          slot: "cardNo"
        },
        {
          label: "联系人",
          name: "Contact",
          option: {
            rules: [{ required: true, message: "联系人必填" }]
          }
        },

        {
          label: "电话",
          placeholder: "请输入电话",
          name: "Phone",
          option: {
            rules: [
              { required: true, message: "联系电话必填" },
              {
                validator: (rule, value, callback) => {
                  const val = value && value.trim();
                  if (val && !/^1[3456789]\d{9}$/.test(val)) {
                    callback(new Error("电话号码格式错误!"));
                  } else {
                    callback();
                  }
                }
              }
            ]
          },
          onChange: e => {
            const val = e.target.value;
            if (/^1[3456789]\d{9}$/.test(val)) {
              this.$post("MemberInfoGetList", {
                Keyword: val,
                PageIndex: 0,
                PageSize: 100
              }).then(res => {
                if (res.Data && res.Data.Datas && res.Data.Datas.length) {
                  const data = res.Data.Datas[0];
                  this.member = data;

                  const formData = this.$refs.guestForm.getData();
                  this.$refs.guestForm.setData({
                    ...formData,
                    Contact: data.Name
                  });
                }
              });
            }
          }
        },
        {
          label: "备注",
          name: "OrderRemark",
          type: "textarea",
          colnum: 3
        }
      ],
      spinning: false,
      loading: false,
      isEdit: false,
      info: {},
      member: {},
      defaultItem: {},
      readLoading: false
    };
  },
  // beforeRouteLeave(to, from, next) {
  //   next(false);
  //   this.$confirm({
  //     title: "确定取消预订吗?",
  //     onOk() {
  //       next(true);
  //     },
  //     onCancel() {
  //       next(false);
  //     }
  //   });
  // },
  created() {
    this.fetchDefaultItem();
  },
  mounted() {
    if (this.$route.query.id) {
      this.fetchData();
      this.isEdit = true;
    } else {
      this.isEdit = false;
      this.$refs.orderForm.setData({
        PersonCount: 1
      });
    }
  },
  methods: {
    fetchDefaultItem() {
      this.$post("Room_GetDefaultTime", {}).then(res => {
        res.Data.SystemConstList.forEach(item => {
          this.defaultItem[item.Code] = item.Value;
        });
      });
    },
    //选择会员卡
    handleMemberCardNo() {
      const that = this;
      MemberListModal({
        option: {
          defaultItem: this.defaultItem
        },
        update: data => {
          that.member = data;
          const guestForm = that.$refs.guestForm;
          guestForm.setData({
            Contact: data.Name,
            Phone: data.Phone
          });
        }
      });
    },
    clearMemberCardNo(e) {
      e.stopPropagation();
      this.member = {};
      const guestForm = this.$refs.guestForm;
      guestForm.setData({
        Contact: "",
        Phone: ""
      });
    },
    readCard() {
      const port = this.defaultItem ? this.defaultItem.LocalServicePort : "";
      const url = "http://localhost:" + port + "/MemberCard/ReadId";
      this.readLoading = true;
      this.$post(url)
        .then(res => {
          if (res.Data) {
            this.getMemberList(res.Data);
          } else {
            this.$message.info("请重新放置会员卡！");
          }
          this.readLoading = false;
        })
        .catch(() => {
          this.readLoading = false;
        });
    },
    getMemberList(physicalId) {
      this.$post("MemberInfoGetList", {
        PhysicalId: physicalId,
        PageIndex: 0,
        PageSize: 100
      }).then(res => {
        if (res.Data && res.Data.Datas && res.Data.Datas.length) {
          const data = res.Data.Datas[0];
          this.member = data;
        } else {
          this.$message.info("查不到该会员卡信息，请重试！");
        }
      });
    },
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },
    fetchData() {
      this.$post("Rest_GetOrderDetail", { Id: this.$route.query.id })
        .then(res => {
          this.info = res.Data;
          this.$refs.orderForm.setData({
            ...this.info
          });
          this.$refs.guestForm.setData({
            Contact: this.info.Contact,
            Phone: this.info.Phone,
            OrderRemark: this.info.OrderRemark
          });
          this.member.Name = this.info.MemberName;
          this.member.Id = this.info.MemberCardId;
          this.inDate = moment(this.info.CheckInTime, "YYYY-MM-DD");
          const time = moment(this.info.CheckInTime).format("HH:mm");
          this.inTime = moment(time, "HH:mm");
        })
        .catch(() => {});
    },
    onSalesmanChange(val, row) {
      this.$nextTick(() => {
        const name = val ? row.Text : "";
        this.$refs.orderForm.setData({
          SalesmanName: name
        });
      });
    },
    async onSubmit(type) {
      const { $refs, $post, inDate, inTime } = this;
      const orderForm = $refs.orderForm;
      const guestForm = $refs.guestForm;
      try {
        const orderFormData = await orderForm.getData(true);
        const guestFormData = await guestForm.getData(true);
        if (!inDate || !inTime) {
          this.$message.error("请选择用餐时间");
          return false;
        }
        let json = {
          ...orderFormData,
          ...guestFormData,
          MemberCardId: this.member.Id,
          IsConfirm: true,
          CheckInTime:
            moment(inDate).format("YYYY-MM-DD") +
            " " +
            moment(inTime).format("HH:mm")
        };
        if (type == 1) {
          cache.remove("booking_info");
          $post("BookingOrder", json).then(() => {
            this.$router.push({
              name: "RestaurantOrderList",
              query: {
                activeKey: "0"
              }
            });
          });
        } else if (type == 0) {
          cache.set("booking_info", json);
          this.$router.push({
            name: "RestaurantBookingFood"
          });
        } else if (type == 2) {
          json = {
            ...this.info,
            ...json
          };
          $post("EditBookingOrder", json).then(() => {
            this.$router.push({
              name: "RestaurantOrderList"
            });
          });
        }
        // eslint-disable-next-line no-empty
      } catch (error) {}
    }
  }
};
</script>
<style lang="less" scoped>
.booking-form-box {
  height: calc(100vh - 130px);
  padding: 10px;
  .footer-action-box {
    padding-right: 10%;
  }
}
</style>
